import React, { createContext, useContext } from 'react';

import ConfirmationMemo from '../components/ConfirmationMemo';

const ConfirmationMemoContext = createContext();

export function useConfirmationMemoContext() {
  return useContext(ConfirmationMemoContext);
}

const ConfirmationMemoApp = (props) => (
  <ConfirmationMemoContext.Provider value={props}>
    <ConfirmationMemo />
  </ConfirmationMemoContext.Provider>
);

export default ConfirmationMemoApp;
